import { FunctionComponent } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { TableContainer, Table as TableMUI, useMediaQuery } from '@material-ui/core';
import TableHeader from './TableHeader';
import { TableBody as TableBodyMUI } from '@material-ui/core';
import { Product } from '@spike/product-model';
import VendorRow from './VendorRow';

interface Props {
    product: Product;
}

const useStyles = makeStyles(() =>
    createStyles({
        tableContainer: {
            display: 'flex',
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflowX: 'auto'
        },
        mobileList: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: '12px'
        }
    })
);

export const Table: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const isMobile = useMediaQuery('(max-width:767.95px)');
    const vendors = props.product?.vendors ?? [];

    if (isMobile) {
        return (
            <div className={classes.mobileList}>
                {vendors.map(v => (
                    <VendorRow
                        key={v.uuid}
                        vendorCost={v}
                        mobile
                    />
                ))}
            </div>
        );
    }

    return (
        <TableContainer className={classes.tableContainer}>
            <TableMUI>
                <TableHeader />
                <TableBodyMUI>
                    {vendors.map(v => (
                        <VendorRow
                            key={v.uuid}
                            vendorCost={v}
                        />
                    ))}
                </TableBodyMUI>
            </TableMUI>
        </TableContainer>
    );
};

export default Table;
